module.exports = __webpack_public_path__ + "img/09钱敏.43f05034.png";